<template>
  <!-- <div class="engloba-item">
    <div>{{ codigo }}</div>
    <div>{{quantidade}}</div>
    <div>{{preco}}</div>
    <div>{{comissao }}</div>
  </div> -->
  <div>{{ this.opcao.text }}</div>
</template>

<script>
import quantidadeDropdownItem from './quantidade-dropdown-item.js' 
export default quantidadeDropdownItem
</script>

<style scoped>
.engloba-item{
    /* display: grid; */
}
@media (min-width:310px) {
    .engloba-item{
        /* grid-template-columns: 33% 33% 33%; */
        /* white-space: break-spaces; */
      display: flex;
      flex-wrap: wrap;
      column-gap: 0.3rem;
    }   

    
}

@media (min-width:368px) {
  .engloba-item{
      column-gap: 3rem;
    }   
}

@media (min-width:600px) {

}

@media (min-width:801px) {

}

@media (min-width:1025px) { 
  /* .engloba-item{
    column-gap: 3rem;
  } */
}

@media (min-width:1281px) { 
    
}

</style>
